import { OnInit, ElementRef, AfterViewInit, EventEmitter } from '@angular/core';
import { TimelineService } from './timeline.service';
var TimelineComponent = /** @class */ (function () {
    function TimelineComponent(timelineService, elementRef) {
        this.timelineService = timelineService;
        this.elementRef = elementRef;
        this.selectedOccurenceChange = new EventEmitter();
        this.index = 0;
    }
    Object.defineProperty(TimelineComponent.prototype, "selectedOccurence", {
        get: function () {
            return this.occurences[this.index];
        },
        set: function (o) {
            this.index = this.occurences.indexOf(o);
            this.timelineService.setIndex(this.index);
        },
        enumerable: true,
        configurable: true
    });
    TimelineComponent.prototype.ngOnInit = function () {
    };
    TimelineComponent.prototype.ngAfterViewInit = function () {
        this.timelineService.timelineElement$.next(this.elementRef.nativeElement);
        this.timelineService.timelineElement$.complete();
        this.timelineService.timelineMoverElement$.next(this.elementRef.nativeElement.querySelector('[mover]'));
        this.timelineService.timelineMoverElement$.complete();
    };
    TimelineComponent.prototype.select = function (occurence) {
        this.selectedOccurence = occurence;
        this.selectedOccurenceChange.emit(occurence);
    };
    TimelineComponent.prototype.recalculate = function () {
        this.timelineService.setIndex(this.index);
    };
    TimelineComponent.prototype.swipe = function (left) {
        if (!left) {
            if (this.index <= 0)
                return;
            this.timelineService.setIndex(--this.index);
        }
        else {
            if (this.index >= this.occurences.length - 1)
                return;
            this.timelineService.setIndex(++this.index);
        }
        this.selectedOccurenceChange.emit(this.selectedOccurence);
    };
    return TimelineComponent;
}());
export { TimelineComponent };
//# sourceMappingURL=timeline.component.js.map